import Modal from './Modal';

export default function ConfirmDialog({message,onConfirm,onCancel,t}){
return(
<Modal open={true} onClose={onCancel} width={400} padding="24px 28px" zIndex={50} t={t}>
<div style={{fontSize:14,fontWeight:600,marginBottom:16,lineHeight:1.4}}>{message}</div>
<div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
<button autoFocus onClick={onCancel} style={{border:`1px solid ${t.bd}`,borderRadius:8,padding:"10px 20px",fontSize:12,fontWeight:600,cursor:"pointer",color:t.tx,background:t.sf,fontFamily:"'DM Sans',sans-serif"}}>Cancel</button>
<button onClick={onConfirm} style={{border:"none",borderRadius:8,padding:"10px 20px",fontSize:12,fontWeight:600,cursor:"pointer",color:"#fff",background:"#c8372d",fontFamily:"'DM Sans',sans-serif"}}>Delete</button>
</div>
</Modal>);
}
